<template>
  <div class="no-print">
    <div class="header">
      <LanguageSwitch></LanguageSwitch>
      <header-bar></header-bar>
    </div>
    <div
      class="d-block d-sm-block d-md-none designer"
      :style="{ background: 'white' }"
    >
      Der GT Designer ist für Anzeigen von 750px Breite optimiert.
    </div>
    <router-view></router-view>
  </div>
  <div id="print"></div>
</template>

<script>
import "./assets/styles/style.scss";
import "bootstrap/scss/bootstrap.scss";
import HeaderBar from "./components/Header.vue";
import LanguageSwitch from "@/views/components/LanguageSwitch.vue";
import { useStore } from "vuex";

export default {
  name: "App",
  components: {
    HeaderBar,
    LanguageSwitch,
  },
  setup() {
    const store = useStore();
    store.dispatch("importXMLs");
    return {};
  },
};
</script>

<style>
@import "./assets/styles/style.scss";
</style>
